module.exports = __webpack_public_path__ + "static/media/menu-boczne-zle-sie-czuje_BLUE.e85d9c05.svg";